import { FieldProperty } from '@shared/types';
export function isGeneralField(field) {
    return field.property in FieldProperty;
}
